// Stable identity for "which advertisers was the URL list fetched for".
//
// The landing-page fetch is cached in Redux across steps and routes, so the
// component needs to tell "already fetched for this scope" apart from "never
// fetched". Doing that by checking whether the list is empty is wrong: an
// advertiser with no non-archived landing pages succeeds with `[]`, which is
// indistinguishable from a cold cache — and refetches forever.
//
// Sorted so [a, b] and [b, a] are the same scope, and String()'d because
// advertiser IDs arrive as both numbers and strings depending on the caller.
export const landingPageScopeKey = (advertiserIds) => {
  if (!Array.isArray(advertiserIds) || advertiserIds.length === 0) return null;

  return [...advertiserIds]
    .map((id) => String(id))
    .sort()
    .join(",");
};
